import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { set as setUI } from '../actions/ui';
import { addError } from '../actions/alerts';
import { TRAY_ALERT_OPEN } from '@instructure/quiz-common';
import flatten from 'lodash/flatten';
import t from '@instructure/quiz-i18n/format-message';
export var handleError = function handleError(dispatch, errorMessage) {
  return function (error) {
    if (error.response && [404, 401].includes(error.response.status)) {
      // need a timeout so focus is not stolen by
      // other callbacks after the alert opens
      setTimeout(function () {
        dispatch(setUI(TRAY_ALERT_OPEN, true));
      }, 500);
    } else if (errorMessage) {
      dispatch(addError(errorMessage));
    } else if (error.response && error.response.status) {
      dispatch(addError(t('Sorry, there was a {status} Error.', {
        status: error.response.status
      })));
    } else {
      dispatch(addError(t('Sorry, there was an error.')));
    }
  };
};

// The Header for QuizEntryEdit has a 200ms delay in componentDidMount before
// moving focus to its title.
// If we try to show the error banner immediately, VoiceOver will begin reading
// it, but get interupted part way through by the focus moving to the Header.
// We need a long enough delay here for the modal to close, the QuizEntryEdit
// header to get mounted, the delay to happen and the focus to move to the title.
// Please forgive me.
var UGLY_HARDCODED_TIMEOUT = 800;
export var getOnErrorWithDelayedValidationMessage = function getOnErrorWithDelayedValidationMessage(dispatch, validationErrorMsg, genericErrorMsg) {
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : UGLY_HARDCODED_TIMEOUT;
  var errMsg = genericErrorMsg;
  var onError = function onError(_ref) {
    var response = _ref.response;
    return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$response$json, errors;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(response && response.status === 422)) {
              _context.next = 11;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return response.json();
          case 4:
            _yield$response$json = _context.sent;
            errors = _yield$response$json.errors;
            if (errorsAllFromValidation(errors)) {
              errMsg = validationErrorMsg;
            }
            _context.next = 11;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
          case 11:
            return _context.abrupt("return", setTimeout(function () {
              return dispatch(addError(errMsg));
            }, timeout));
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
  };
  return onError;
};

// ==============================
// ==============================
//  API INPUT VALIDATION HELPERS
// ==============================
// ==============================

var validationTextForError = function validationTextForError(errorType) {
  if (errorType === 'regexp') {
    return t('Invalid Regular Expression');
  }
  return t('Unknown validation error');
};
export var errorsAllFromValidation = function errorsAllFromValidation(errors) {
  var errorArray = flatten(Object.values(errors));
  // All api errors are just part of input validation flow
  // Don't show the error banner, validation feedback should be shown
  // at input level
  return errorArray.every(function (error) {
    return error.validation_error;
  });
};
export var processApiError = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fetcherError) {
    var response, unprocessableEntityCode, _yield$response$json2, errors, validationErrorsArray, validationErrorsObject, validationError;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          response = fetcherError.response;
          unprocessableEntityCode = 422;
          if (!(response && parseInt(response.status) === unprocessableEntityCode)) {
            _context2.next = 15;
            break;
          }
          _context2.next = 5;
          return response.json();
        case 5:
          _yield$response$json2 = _context2.sent;
          errors = _yield$response$json2.errors;
          validationErrorsArray = flatten(Object.values(errors)).filter(function (error) {
            return error.validation_error;
          });
          if (validationErrorsArray.length) {
            _context2.next = 10;
            break;
          }
          throw fetcherError;
        case 10:
          validationErrorsObject = {};
          validationErrorsArray.forEach(function (error) {
            validationErrorsObject[error.input_id] = validationErrorsObject[error.input_id] || [];
            validationErrorsObject[error.input_id].push({
              type: 'error',
              text: validationTextForError(error.error_type)
            });
          });
          validationError = Object.assign(Object.create(Error.prototype), fetcherError);
          validationError.validationErrorsFromApi = validationErrorsObject;
          throw validationError;
        case 15:
          throw fetcherError;
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function processApiError(_x) {
    return _ref3.apply(this, arguments);
  };
}();